import React from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const DeleteProduct = ({
  openDeleteState,
  setDeleteIndex,
  removeReview,
  // checkout_data,
}) => {
  const classes = useStyles();

  // const sku = checkout_data.sku;
  const [openDelete, setOpenDelete] = openDeleteState;

  const onClose = () => {
    setOpenDelete(false);
    setDeleteIndex(null);
  };

  const onDelete = () => {
    removeReview();
    onClose();
  };

  return (
    <Dialog
      disableBackdropClick
      fullWidth
      maxWidth="xs"
      open={openDelete}
      onClose={onClose}
    >
      <DialogTitle> Delete Review </DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure to <strong> delete </strong> this review ?{" "}
        </Typography>{" "}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onDelete}
        >
          Yes{" "}
        </Button>{" "}
        <Button
          variant="contained"
          color="secondary"
          className={classes.button}
          onClick={onClose}
        >
          No{" "}
        </Button>{" "}
      </DialogActions>{" "}
    </Dialog>
  );
};

export default DeleteProduct;
